<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>Lọc thông tin</h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="12" class="mb-md-0 mb-2">
          <b-form-group>
            <label class="d-flex justify-content-between">
              <span>Cơ quan hiện tại</span>
              <b-form-checkbox
                v-model="filters.isChildren"
                class="custom-control-primary"
                @change="onInput"
              >
                Cả cơ quan con
              </b-form-checkbox>
            </label>
            <treeselect
              v-on:select="formatDonVis"
              :options="options"
              value-format="object"
              v-model="filters.donVi"
              :searchable="true"
              :show-count="true"
              :clearable="true"
              :default-expand-level="1"
              :normalizer="normalizer"
              placeholder=""
              @input="$emit('fetch-data', filters)"
            />
          </b-form-group>
        </b-col>
        <!-- <b-col cols="12" md="12" class="mb-md-0 mb-2">
          <label>Cơ quan</label>
          <v-select
            class="w-100"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="options"
            :reduce="(val) => val.id"
            :value="defaultOption.value"
            label="name"
            :clearable="false"
            @input="onInput"
          />
        </b-col> -->
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BFormGroup, BFormCheckbox } from "bootstrap-vue";
import vSelect from "vue-select";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormCheckbox,
    BCardHeader,
    BCardBody,
    vSelect,
    Treeselect,
  },
  data() {
    return {
      // define the default value
      value: null,
      filters: {
        isChildren: true,
      },
      // define options
      // listCoQuan: [],
    };
  },
  watch: {
    defaultOption() {
      // console.log("defaultOption", this.defaultOption);
      this.filters.donVi = this.defaultOption;
    },
  },
  created() {
    this.value = JSON.parse(localStorage.getItem("donViFilter"));
    this.filters.donVi = this.value ? this.value : null;
    this.$emit("fetch-data", this.filters);
  },
  methods: {
    onInput(val) {
      this.defaultOption.value = val ? val.id : val;
      this.$emit("fetch-data", this.filters);
    },
    formatDonVis(node, instanceId) {
      // this.model.chuDauTu = {id: node.id, ten: node.label};
    },
    normalizer(node) {
      // console.log(node);

      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },
  },
  props: {
    defaultOption: {
      type: Object,
    },
    options: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
